import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Drawer, {
  DrawerItem,
  DrawerItemContent,
  DrawerItemTitle
} from 'dpl/common/components/Drawer';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_LARGE = isLessThanBreakpoint('lg');

/** @param {any} props */
export default function FaqDrawer({
  faqs,
  iconCloseName = 'fetch-plus',
  iconOpenName = 'fetch-minus',
  iconClassName = 'black',
  hideLastBorder = false,
  setAnswerInnerHtml = false
}) {
  return faqs.map((faq, idx) => (
    <Drawer key={idx} initialOpenKey={faq.question}>
      <DrawerItem
        className={classnames({
          'bb b--gray-300': hideLastBorder ? idx < faqs.length - 1 : true
        })}
        itemKey={faq.question}
      >
        <DrawerItemTitle
          iconClassName={iconClassName}
          iconOpenName={iconOpenName}
          iconCloseName={iconCloseName}
          iconSize={IS_LT_LARGE ? '24px' : '48px'}
        >
          <h5 className="pv2 flex items-center font-16 lg:font-24 lh-normal">
            {faq.question}
          </h5>
        </DrawerItemTitle>
        <DrawerItemContent>
          {setAnswerInnerHtml ? (
            <p
              className="mb3 font-16-mobile secondary w-100 w-60-lg"
              /* eslint-disable-next-line react/no-danger */
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            />
          ) : (
            <p className="mb3 font-16-mobile secondary w-100 w-60-lg">
              {faq.answer}
            </p>
          )}
        </DrawerItemContent>
      </DrawerItem>
    </Drawer>
  ));
}

FaqDrawer.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string
    })
  ).isRequired,
  iconCloseName: PropTypes.string,
  iconOpenName: PropTypes.string,
  hideLastBorder: PropTypes.bool,
  iconClassName: PropTypes.string,
  setAnswerInnerHtml: PropTypes.bool
};
